'use client'

import { Button } from '@repo/design-system-cf/components/button'
import { useTranslations } from 'next-intl'
import * as React from 'react'
import { Link } from '@repo/web-ui/components/link'

export const BuyForButton = ({ url }: { url?: string }) => {
  const t = useTranslations('pages.daily-gifts.categories')

  return (
    <div className="flex flex-col gap-2">
      <div>
        <Button variant="secondary" className="mt-3" fullWidth asChild>
          <Link href={url}>
            <span className="uppercase font-bold">{t('download_for_free')}</span>
          </Link>
        </Button>
      </div>
    </div>
  )
}
